import React, {FC} from "react";
import Button from "@mui/material/Button";
import Hidden from "@mui/material/Hidden";
import Typography from "@mui/material/Typography";
import {parseISO} from "date-fns";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import Grid from "@mui/material/Grid";
import {useTranslation} from "next-i18next";
import {Box} from "@mui/material";
import {styled} from "@mui/material/styles";
import useWidth from "../../hooks/use-width";


const NavButton = styled(Button)(({theme}) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.1rem",
    paddingLeft: 0,
    paddingRight: 0,
    minWidth: 50
  }
}))


interface PricingPeriodSelectorProps {
  packagePeriod: string;
  onNext: () => void;
  onPrev: () => void;
  hasPrev: boolean;
  hasNext: boolean
}


export const PricingPeriodSelector:FC<PricingPeriodSelectorProps> = ({ packagePeriod, onPrev, onNext, hasNext, hasPrev }) => {
  const { t, i18n } = useTranslation();


  const singleMonthFormatter = new Intl.DateTimeFormat(i18n.language, {
    year: "numeric",
    month: "long"
  });

  const multiMonthFormatter = new Intl.DateTimeFormat(i18n.language, {
    year: "numeric",
    month: "short"
  });

  const fullScreen = useWidth() === "xs"

  const getTitle = (packagePeriod:string) => {
    if (packagePeriod) {
      const [from, to] = packagePeriod.split("_");

      if (to !== undefined) {
        // must be a season
        return (
          multiMonthFormatter.format(parseISO(from)) +
          " - " +
          multiMonthFormatter.format(parseISO(to))
        );
      } else {
        return singleMonthFormatter.format(parseISO(from));
      }
    } else {
      return t("loading") + "...";
    }
  };



  return (
    <Box textAlign={"center"}>
      <Grid
        container
        spacing={0}
        justifyContent={"space-evenly"}
        alignItems={"baseline"}
      >
        <Grid item>
          <NavButton
            color="primary"
            variant={fullScreen? "contained": "text"}
            disabled={!hasPrev}
            onClick={onPrev}
            style={{ marginLeft: 8 }}
            aria-label={"Previous Month"}
          >
            <KeyboardArrowLeft style={{ marginBottom: 5 }} />
            <Hidden smDown>{t("prev")}</Hidden>
          </NavButton>
        </Grid>
        <Grid item style={{ flexGrow: 1, textAlign: "center" }}>
          <Typography
              sx={{
                minWidth: 180,
                position: "relative",
                textTransform: "uppercase",
                fontSize: {
                  xs: "1.1rem",
                  md: "1.5rem"
                }
              }}
          >
            {getTitle(packagePeriod)}
          </Typography>
        </Grid>
        <Grid item>
          <NavButton
            color="primary"
            variant={fullScreen? "contained": "text"}
            disabled={!hasNext}
            onClick={onNext}
            style={{ marginRight: 8 }}
            aria-label={"Next Month"}
          >
            <Hidden smDown>{t("next")}</Hidden>
            <KeyboardArrowRight style={{ marginBottom: 5 }} />
          </NavButton>
        </Grid>
      </Grid>
    </Box>
  );
}



